import { GET_TRENDS, TRENDS_ERROR } from "../actions/types";

const initialState = {
  trends: [],
  loading: true,
  error: {}
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TRENDS:
      return {
        ...state,
        trends: payload,
        loading: false
      };

    case TRENDS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
};
